// TODO add settings for this
export const defaultCurrency = "EUR";

export const currencyOptions = [{ value: "RON" }, { value: "USD" }];
